@if (!statistics.alarmCenterTabPagingComplete) {
  <div>
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
    <p style="margin-top: 0.5rem;">
      {{ 'ALERTS_LOADED' | translate }}: {{ totalAlerts }}
    </p>
  </div>
}
@if (statistics.alarmCenterTabPagingComplete && emaacStatisticsData) {
  <div class="row">
    <div class="col stat-sidebar-col">
      <div>
        <care-recipient-counter [careRecipientCount]="emaacStatisticsData.careRecipientCount"></care-recipient-counter>
      </div>
      <div class="mt-3">
        <emaac-alerts [emaacAlertStats]="emaacStatisticsData.emaacAlertStats"></emaac-alerts>
      </div>
      <div class="mt-3">
        <response-time-statistics [resTimeStats]=" emaacStatisticsData.responseTimes.resTimeStats"></response-time-statistics>
      </div>
    </div>
    <div class="col stat-graphs-col">
      <div>
        <alerts-by-alarm-reason [alertsByAlarmReasons]="emaacStatisticsData.alertsByAlarmReasons"
          [translations]="alarmReasonTranslations">
        </alerts-by-alarm-reason>
      </div>
      <div class="mt-3">
        <alerts-per-day [alertsByDays]="emaacStatisticsData.alertsByDays">
        </alerts-per-day>
      </div>
      <div class="mt-3">
        <alerts-per-hour [alertsByHours]="emaacStatisticsData.alertsByHours">
        </alerts-per-hour>
      </div>
      <div class="mt-3">
        <response-time-histogram [responseTimes]="emaacStatisticsData.responseTimes">
        </response-time-histogram>
      </div>
      <div class="mt-3">
        <alert-response-times [responseTimes]="emaacStatisticsData.responseTimes.alertResponses"></alert-response-times>
      </div>
    </div>
  </div>
}
@if (statistics.alarmCenterTabPagingComplete && !emaacStatisticsData) {
  <div class="text-center mt-4">
    {{ 'NO_RESULTS' | translate }}
  </div>
}
